import { Trial, ResponseStatus, ConfigurationTrial } from "@/api/dtos";
import { createContext, Dispatch, SetStateAction } from "react"

export interface ISourceDataItemGroupGridContext {
    itemGroupName?: string;
    setItemGroupName: Dispatch<SetStateAction<string | undefined>>;
}

export const SourceDataItemGroupGridContext = createContext<ISourceDataItemGroupGridContext>({
    itemGroupName: undefined,
    setItemGroupName: ((value?: string) => {
    }) as any
});

export default SourceDataItemGroupGridContext;